<header>
    @if (presentation() === 'standard') {
        <ng-content select="[prefix]" />
    }

    <div class="inline-flex flex-col">
        <h2 qpxHeading variant="lg" [id]="titleId()">
            <span>{{ title() }}</span>
        </h2>

        @if (presentation() === 'standard') {
            <ng-content select="[qpxDialogSubtitle]" />
        }
    </div>

    @if (presentation() === 'standard') {
        <ng-content select="[suffix]" />
    }
</header>

@if (presentation() === 'standard') {
    <section class="header-actions" aria-label="Primary actions">
        <ng-content select="[actions]" />

        @if (showCloseButton()) {
            <button
                qpxButton
                matButton="outlined"
                (click)="onDismiss()"
                class="icon-only -mr-2"
            >
                <ng-icon
                    qpx
                    class="text-foreground"
                    name="lucideX"
                    matButtonIcon
                />
                <span class="sr-only">{{ closeLabel() }}</span>
            </button>
        }
    </section>
}
